import { useRef, useState } from "react";

import {useScenarioType} from "../ScenarioTypeContext"
import { useDebug } from '../../../scripts/custom-hooks.js';
import Medication from "./Medication";
import SaveButton from "./SaveButton";

const copyObj = (obj) => JSON.parse(JSON.stringify(obj));

const Medications = () => {
    const {scenarioType, saveMedications} = useScenarioType()
    const [meds, setMeds] = useState(scenarioType.medications)
    const formRef = useRef();

    useDebug(() => console.log(meds));

    const saveHandler =  async (event) => {
        event.preventDefault()
        const result = await saveMedications(sortMeds())
        if (result) {
            console.log("changes saved successfully")
            alert("Changes saved.")
        } else {
            console.log("an error occured while saving")
        }
    }

    const nonGeneralFields = {
        contraindicated: false,
        repeatable: false,
        routes: [],
        initialDosage: "",
        repeatDosage: "",
        maxDosage: "",
        maxTotalDosage: "",
        repeatInterval: "",
    };

    const addMed = () => setMeds([...meds, { 
        id: "",
        label: "",
        contraindications: [],
        indications: [],
        adult: copyObj(nonGeneralFields), 
        pediatric: copyObj(nonGeneralFields),
    }]);

    const sortMeds = () => {
        let sorted = meds.slice();
        sorted.sort((a, b) => 
            a.id.localeCompare(b.id));
        setMeds(sorted);
        return sorted;
    }

    return (
        <>
        <div>
            <SaveButton clickHandler={saveHandler} />
            <button type="button" onClick={sortMeds}>Sort A to Z</button>
        </div>

        <div className="medications-form" ref={formRef}>
            {meds && meds.map((med, i) => (
                <Medication key={med.id || i} med={med} index={i} medState={[meds, setMeds]} />
            ))}
            <button type="button" onClick={addMed}>New Medication</button>
        </div>
        <div><SaveButton clickHandler={saveHandler} /></div>
        </>
    )
}

export default Medications